module.exports = "/assets/data/ee0d7810d8a385835c31970c1f9854ce-KT4.data.json";